<div class="schedule-summary">
   <div class="pl-72 pr-72" [ngClass]="{'pt-24': !(showDRBanner$ | async), 'pt-8': (showDRBanner$ | async)}">
       <app-breadcrumb class="mt-16" [items]="breadcrumbItems">
       </app-breadcrumb>
    </div>
    <div class="bookmark" [ngClass]="{'mt--18': !(showDRBanner$ | async), 'mt--34': (showDRBanner$ | async)}">
       <img class="tag" src="/assets/images/tag.svg" />
       <span class="mat-body fs-12 fw-500 tag-text">{{'SCHEDULE_DETAILS.SCHEDULER' | transloco}}</span>
    </div>
    <div class="flex flex-row details justify-between">
      <div class="flex flex-row">
         <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0"
            [routerLink]="['/', authService.principal.provider, RouterSegments.TENANT, schedules?.tenantId, RouterSegments.SCHEDULE]"></mat-icon>
         <div class="mat-subtitle-1 schedule-detail fw-600 fs-24 ml-12 mb-0">{{ 'SCHEDULE_DETAILS.SCHEDULE_TITLE' | transloco }}</div>
      </div>
      <div>
         <button *ngIf="schedules?.status === 'active'" type="submit" class="flex disable h-32 fw-700 place-items-center" (click)="onDisableSchedule()"><mat-icon svgIcon="block" class="mr-4 icon-sm"></mat-icon>{{'BUTTONS.DISABLE' | transloco}}</button>
         <button *ngIf="schedules?.status === 'disabled'" type="submit" class="flex enable h-32 fw-700 place-items-center" (click)="onEnableSchedule()"><mat-icon svgIcon="check" class="mr-4 icon-sm"></mat-icon>{{'BUTTONS.ENABLE' | transloco}}</button>
      </div>
    </div>
     <div class="details-card">
      <div class="schedule-grid">
         <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.INSTANCE_NAME' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">
                  <span class="clickable underline text-primary" (click)="navigateToInstance(instance)">
                     {{ schedules.metadata?.instanceName || '-' }}
                  </span>
               </ng-container>
             </span>
          </div>
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.SERVICE_DEFINITION' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">
                  <span class="clickable underline text-primary" (click)="navigateToBlueprint(id)">
                     {{ schedules.metadata?.blueprintName || '-' }}
                  </span>
               </ng-container>
             </span>
          </div>
      </div>
     </div>
    <div class="details-card">
       <div class="schedule-grid">
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.SCHEDULE_NAME' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">{{ schedules.name.includes('-') ? (schedules.name.split('-')[0].trim() | titlecase) : schedules.name ? (schedules.name | titlecase) : '-' }}</ng-container>
             </span>
          </div>
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.DESCRIPTION' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">{{ schedules.description ? (schedules.description | titlecase) : '-' }}</ng-container>
             </span>
          </div>
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.NEXT_RUN_DATE' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">{{ schedules.nextExecutionTime ? (schedules?.nextExecutionTime | date: 'dd MMM yyyy, HH:mm:ss' : 'UTC') : '-' }}</ng-container>
             </span>
          </div>
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.START_DATE' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">{{ schedules.startTime ? (schedules?.startTime | date: 'dd MMM yyyy, HH:mm:ss' : 'UTC') : '-' }}</ng-container>
             </span>
          </div>
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.END_DATE' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">{{ schedules.endTime ? (schedules?.endTime | date: 'dd MMM yyyy, HH:mm:ss' : 'UTC') : '-' }}</ng-container>
               </span>
          </div>
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.STATUS' | transloco }}</span>
             <div class="flex items-center">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
                <div *ngIf="schedules" class="flex items-center status pl-8 pr-8 pt-2 pb-2" [ngClass]="schedules.status">
                   <span>
                      <mat-icon *ngIf="schedules.status !== 'running' && schedules.status !== 'inprogress'" [svgIcon]="schedules.status === 'completed' ? 'check_circle' : schedules.status === 'failed' ? 'report_problem' :
                      schedules.status === 'deleted' ? 'delete' : schedules.status === 'disabled' ? 'block' : schedules.status === 'active' ? 'check_circle' : schedules.status === 'pending' ? 'hourglass_empty' : ''" class="icon-md p-2 mr-6" [ngClass]="schedules.status"></mat-icon>
                      <mat-spinner *ngIf="schedules.status === 'running' || schedules.status === 'inprogress'" diameter="16" class="mr-8"
                         color="primary"
                         mode="indeterminate">
                      </mat-spinner>
                   </span>
                   <span>{{schedules.status === 'active' ? 'Active' : schedules.status === 'completed' ? 'Completed' : schedules.status === 'deleted' ? 'Deleted' : schedules.status === 'running' ? 'Running' : schedules.status === 'inprogress' ? 'Inprogress' : schedules.status === 'disabled' ? 'Disabled' : schedules.status === 'failed' ? 'Failed' : '-'}}</span>
                </div>
             </div>
          </div>
          <div class="grid-item">
            <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.TRIGGERS' | transloco }}</span>
            <span class="value fs-16 fw-400">
              <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
              <ng-container *ngIf="schedules">{{ schedules.frequency ? schedules.frequency : '-' }}</ng-container>
            </span>
         </div>          
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.CREATED_DATE' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">{{ schedules.createdAt ? (schedules?.createdAt | date: 'dd MMM yyyy, HH:mm:ss' : 'UTC') : '-' }}</ng-container>
               </span>
          </div>
          <div class="grid-item">
            <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.CREATED_BY' | transloco }}</span>
            <span class="value fs-16 fw-400">
              <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
              <ng-container *ngIf="schedules">{{ schedules.createdBy ? schedules.createdBy : '-' }}</ng-container>
            </span>
          </div>
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.MODIFIED_DATE' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">{{ schedules.updatedAt ? (schedules?.updatedAt | date: 'dd MMM yyyy, HH:mm:ss' : 'UTC') : '-' }}</ng-container>
             </span>
          </div>
          <div class="grid-item">
            <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.MODIFIED_BY' | transloco }}</span>
            <span class="value fs-16 fw-400">
              <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
              <ng-container *ngIf="schedules">{{ schedules.modifiedBy ? schedules.modifiedBy : '-' }}</ng-container>
            </span>
          </div>
          <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.LAST_RUN_DATE' | transloco }}</span>
             <span class="value fs-16 fw-400">
               <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
               <ng-container *ngIf="schedules">{{ schedules.lastExecutionTime ? (schedules?.lastExecutionTime | date: 'dd MMM yyyy, HH:mm:ss' : 'UTC') : '-' }}</ng-container>
             </span>
          </div>
          <div class="grid-item">
            <span class="label fs-16 fw-600">{{ 'SCHEDULE_DETAILS.CRON_DEFINITION' | transloco }}</span>
            <span class="value fs-16 fw-400">
             <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
             <ng-container *ngIf="schedules">{{ schedules.cronDefinition ? schedules.cronDefinition : '-' }}</ng-container>
            </span>
         </div>
         <div class="grid-item">
            <span class="label fs-16 fw-600">{{ 'INSTANCE_DETAILS.RELEASE_PACKAGE' | transloco }}</span>
            <span class="value fs-16 fw-400">
             <ngx-skeleton-loader *ngIf="!schedules" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
             <ng-container *ngIf="schedules">{{ releaseVersion ? releaseVersion : '-' }}</ng-container>
            </span>
         </div>
         <div class="grid-item">
            <span class="label fs-16 fw-600">{{ 'INSTANCE_DETAILS.TARGET_RELEASE_VERSION' | transloco }}</span>
            <span class="value fs-16 fw-400">
             <ngx-skeleton-loader *ngIf="!schedules || isSolutionLoading" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
             <ng-container *ngIf="schedules && !isSolutionLoading">{{ targetSolutionVersion ? targetSolutionVersion : '-' }}</ng-container>
            </span>
         </div>
          <div class="grid-item">
            <span class="label fs-16 fw-600">{{ 'CUSTOM_IMAGES.CUSTOM_IMAGE' | transloco }}</span>
            <span class="value fs-16 fw-400">
             <ngx-skeleton-loader *ngIf="!schedules || isCustomImageLoading" class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
             <ng-container *ngIf="schedules && !isCustomImageLoading">{{ packageReference ? packageReference : '-' }}</ng-container>
            </span>
         </div>
       </div>
    </div>
    <div class="flex flex-row items-center justify-between header-section">
      <div class="flex items-center schedule-history pt-20">
          <div class="mat-subtitle-2 mb-0 fs-24 fw-500 pl-20">{{'SCHEDULE_DETAILS.JOB_HISTORY' | transloco}}
            <span class="ml-2" *ngIf="scheduleHistory">
            ({{scheduleHistory.length}})
            </span>
          </div>
         <div class="ml-24">
            <button *ngIf="initialHistory?.length > 0" class="flex justify-center items-center schedule-filter pl-6 pr-16 h-34" (click)="filterColumns()">
               <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
               <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
            </button>
         </div>
        </div>
      </div>
      <div *ngIf="initialHistory?.length > 0" class="flex flex-row items-center mt-8 ml-68 mt-32 mb-16">
         <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
               <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
                  {{getStatusLabel(status)}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
               </span>
         </div>
         <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="filterStartDate && filterEndDate">
            <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
               <span class="date-label">{{'SCHEDULE_DETAILS.LAST_RUN_DATE' | transloco}}:</span>
               {{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
               <span class="ml-8">
               <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelScheduleDateFilter()"></mat-icon>
               </span>
            </span>
         </div>
         <div class="flex flex-row items-center">
            <span *ngIf="selectedStatus?.length > 0 || (filterStartDate && filterEndDate)" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetScheduleFilter()">
               {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
         </div>
      </div>
      <div class="pl-66 pr-66 pb-24 tenant-schedule-wrapper">
         <div *ngIf="!scheduleHistory" class="flex spinner-container spinner">
             <mat-spinner diameter="24"
               color="primary"
               mode="indeterminate">
             </mat-spinner>
         </div>
         <app-table *ngIf="initialHistory?.length > 0" [ngClass]="{'disabled': showLoader}" [initialDataSource]="scheduleHistory" [displayColumns]="displayColumns" [dataLoading]="schedulesLoading" [showSkeletonLoader]="false" [dataSourceLength]="true" page="schedule" pageName="scheduleDetails"></app-table>
            <div *ngIf="initialHistory?.length === 0 && !schedulesLoading" class="flex justify-center items-center empty-wrapper mt-40">
               <div class="text-center">
                     <img src="assets/images/no-schedules.png" alt="No schedules" class="empty-img" />
                     <p class="empty-msg fs-16 fw-500">{{'SCHEDULE_DETAILS.NO_SCHEDULE_HISTORY' | transloco}}</p>
               </div>
            </div>
      </div>
      <div *ngIf="showLoader">
         <mat-card class="flex spinner-container load-spinner">
            <mat-spinner diameter="24"
               color="primary"
               mode="indeterminate">
            </mat-spinner>
         </mat-card>
      </div>
      